<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="6" :xs="24">
        <el-card>
          <div slot="header" >
            <span>用户信息</span>
          </div>
          <div >
            <div class="text-center">
              <userAvatar/>
            </div>
            <ul class="list-group">
              <li class="list-group-item">
                <svg-icon icon-class="user" />用户昵称
                <div class="pull-right">{{ userInfo.nickname }}</div>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="user-manage" />用户账号
                <div class="pull-right">{{ user.username }}</div>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="role" />所属角色
                <div class="pull-right">{{ user.roleName || '无角色' }}</div>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="email" />用户邮箱
                <div class="pull-right">{{ userInfo.email }}</div>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="login-type" />登录类型
                <div class="pull-right">{{ loginTypeLabel || '未知'  }}</div>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="ip" />登录IP
                <div class="pull-right">{{ user.ipAddr }}</div>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="area" />登录地址
                <div class="pull-right">{{ user.ipSource }}</div>
              </li>
              <li class="list-group-item">
                <svg-icon icon-class="date" />最后登录时间
                <div class="pull-right">{{ user.lastLoginTime | dateTime}}</div>
              </li>
            </ul>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18" :xs="24">
        <el-card>
          <el-tabs v-model="activeName">
            <!-- 修改信息 -->
            <el-tab-pane label="修改信息" name="info">
              <userInfo :user="userInfo"/>
            </el-tab-pane>
            <!-- 修改密码 -->
            <el-tab-pane label="修改密码" name="password">
              <resetPwd />
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import userInfo  from "./userInfo";
import userAvatar from './userAvatar'
import resetPwd from './resetPwd'
import { getUserProfile } from "@/api/system/user"
export default {
  components: {userInfo,userAvatar, resetPwd},
  dicts: ['login_type'],
  created() {
    this.getUserInfo();
  },
  data: function() {
    return {
      user:{},
      userInfo:{},
      activeName: "info",
      headers: {
        Authorization: "Bearer " + this.$store.getters.token
      }
    };
  },
  methods: {
    getUserInfo(){
      getUserProfile().then(res => {
        this.user = res.data;
        this.userInfo = res.data.userInfo
      })
    }
  },
  computed: {
    avatar() {
      return this.$store.getters.avatar;
    },
    loginTypeLabel() {
      return this.selectDictLabel(this.dict.type.login_type, this.user.loginType) || '-'
    },
  }
};
</script>
